import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import React, {useState} from 'react';
import NoteEdition from './NoteEdition';
import NoteHeader from './NoteHeader';
import NoteList from './NoteList';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '600px',
    height: '100%',
    overflowX: 'hidden'
  }
}));

const NotesContainer = ({
  handleDeleteNote,
  handleSaveNote,
  notes,
  noteEditionMode,
  onCloseDrawer,
  setNoteEditionMode,
  isLoadingNote,
  getUnreadNotesNumber
}) => {
  const classes = useStyles();
  const [selectedNote, setSelectedNote] = useState(null);

  const handleEditNote = note => {
    setSelectedNote(note);
    setNoteEditionMode(true);
  }

  const handleCreateNote = () => {
    setSelectedNote(null);
    setNoteEditionMode(true);
  }

  return (
    <div className={classes.container}>
      <Grid container direction="column" spacing={1} style={{height: '100%'}} wrap="nowrap">
        <Grid item>
          <NoteHeader onCloseButtonClick={onCloseDrawer}/>
        </Grid>
        {noteEditionMode ?
          <NoteEdition handleSaveNote={handleSaveNote} isLoadingNote={isLoadingNote} note={selectedNote} setNoteEditionMode={setNoteEditionMode}/>
          :
          <NoteList
            getUnreadNotesNumber={getUnreadNotesNumber}
            handleCreateNote={handleCreateNote}
            handleDeleteNote={handleDeleteNote}
            handleEditNote={handleEditNote}
            isLoadingNote={isLoadingNote}
            notes={notes}
          />
        }
      </Grid>
    </div>
  );
};

export default NotesContainer;